export default "__VITE_ASSET__c8c751b4__"